export default __webpack_public_path__ + "static/21-c809f2f39510a775a5bae33f33223bb1.jpg";